import endsWith from './helpers/endsWith';
import stripUnit from './helpers/stripUnit';
export default (pxval, base = '16px') => {
    const to = 'rem';
    let newPxval = pxval;
    let newBase = base;
    if (typeof pxval === 'string') {
        if (!endsWith(pxval, 'px')) {
            throw new Error('Expected a value in string ending in "px"');
        }
        newPxval = stripUnit(pxval);
    }
    if (typeof base === 'string') {
        if (!endsWith(base, 'px')) {
            throw new Error('Expected a base value in string ending in "px"');
        }
        newBase = stripUnit(base);
    }
    if (typeof newPxval === 'string') {
        throw new Error('Passed invalid pixel value for value.');
    }
    if (typeof newBase === 'string') {
        throw new Error('Passed invalid base value for base.');
    }
    return `${newPxval / newBase}${to}`;
};
//# sourceMappingURL=rem.js.map